"use client";

import { useEffect } from "react";

/**
 * ConsoleMessage
 * Renders a mesage in the JS console to any would-be warriors
 */
export function ConsoleMessage() {
    useEffect(() => {
        if (process.env.NODE_ENV !== "development") {
            console.log("%cHello there 👋", "color: #60EA94; font-size: 24px;");
            console.log("%cNeed Data?", "color: #60EA94; font-size: 18px;");
            console.log(
                "%cSave yourself some trouble and skip the console and network tools.",
                "color: #60EA94; font-size: 14px;",
            );
            console.log(
                "%cChat with our team about our data solutions and API offerings ",
                "color: #60EA94; font-size: 14px;",
            );
            console.log(
                "%cWe would be thrilled to hear from you!",
                "color: #60EA94; font-size: 14px;",
            );
            console.log(
                "%cWARNING: Redistributing data without explicit permission is a violation of the RWA.xyz terms of service.",
                "color: #E4355C; font-size: 12px;",
            );
        }
    }, []);

    return null;
}
